// Librerias
import React from 'react'
import api from '../../apiClient/v1'
let PropTypes = React.PropTypes
// Componentes
import { TablaPendientes } from './TablaPendientes.jsx'

// ReactNotify
import ReactNotify from 'react-notify'
import * as ReactNotifyCSS from '../../shared/ReactNotify/ReactNotify.css'

export class OperadoresPendientes extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            usuariosRAW: [],
            usuarios: [],
            busquedaComuna: '',
            busquedaRUN: '',
            busquedaNombre: '',
            busquedaApellido: '',
            busquedaCaptador: '',
            checked: false,
            canceled: false
        }

        this.ajaxErrorHandler = (errorTitle) => {
            return (err) => {
                if (err.status == 500)
                    return this.refs.notificator.error("Error critico en el servidor", "Contactese con el departamento de informática.", 4 * 1000);
                let msgs = _.values(err.data).join('. ')
                console.log(err)
                console.log(errorTitle, err.data)
                this.refs.notificator.error(errorTitle, msgs, 4 * 1000);
            }
        }
        this.fetchUsuarios = () => {
            this.setState({
                usuariosRaw: []
            })
            api.usuarios.fetchPendientes()
                .then(usuarios => {
                    this.setState({
                        usuariosRAW: usuarios,
                    }, this.filtrarUsuarios)
                })
        }
        this.confirmarOperador = (data) => {
            api.usuarios.confirmarOperador(data)
                .then(usuarios => {
                    this.filtrarUsuarios
                    this.setState({
                        checked: true
                    })
                })
        }
        this.realizarBusqueda = (campo, busquedaOriginal) => {
            let newState = {}
            newState[campo] = busquedaOriginal.trim().toLowerCase()
            this.setState(newState, this.filtrarUsuarios)
        }
        this.filtrarUsuarios = () => {
            this.setState({
                usuarios: this.state.usuariosRAW
                    .filter(us => us.RUN.indexOf(this.state.busquedaRUN) >= 0)
                    .filter(us => us.apellidoPaterno.toLowerCase().indexOf(this.state.busquedaApellido) >= 0 || us.apellidoMaterno.toLowerCase().indexOf(this.state.busquedaApellido) >= 0)
                    .filter(us => us.nombre1.toLowerCase().indexOf(this.state.busquedaNombre) >= 0 || us.nombre2.toLowerCase().indexOf(this.state.busquedaNombre) >= 0)
                    .filter(us => us.captador.toLowerCase().indexOf(this.state.busquedaCaptador) >= 0)
                    .filter(us => us.comuna.toLowerCase().indexOf(this.state.busquedaComuna) >= 0)
            })
        }
    }
    componentWillMount() {
        this.fetchUsuarios()
    }
    render() {
        return (
            <div>
                {console.log(this.state.usuarios)}
                <ReactNotify ref='notificator' className={ReactNotifyCSS} />
                <div className="row">
                    <div className="col-md-6">
                        <h1>Operadores Pendientes</h1>
                    </div>
                </div>

                <TablaPendientes
                    usuarios={this.state.usuarios}
                    perms={this.props.perms}
                    // busqueda
                    busquedaComuna={this.state.busquedaComuna}
                    realizarBusquedaComuna={this.realizarBusqueda.bind(this, 'busquedaComuna')}
                    busquedaRUN={this.state.busquedaRUN}
                    realizarBusquedaRUN={this.realizarBusqueda.bind(this, 'busquedaRUN')}
                    busquedaNombre={this.state.busquedaNombre}
                    realizarBusquedaNombre={this.realizarBusqueda.bind(this, 'busquedaNombre')}
                    busquedaApellido={this.state.busquedaApellido}
                    realizarBusquedaApellido={this.realizarBusqueda.bind(this, 'busquedaApellido')}
                    busquedaCaptador={this.state.busquedaCaptador}
                    realizarBusquedaCaptador={this.realizarBusqueda.bind(this, 'busquedaCaptador')}
                    fetchUsuarios={this.fetchUsuarios}
                    confirmarOperador={this.confirmarOperador}
                    checked={this.state.checked}
                    canceled={this.state.canceled}
                />
                {/*<TablaPendientes
                    usuarios={this.state.usuariosRAW}
                    //comunas={this.state.comunas}
                    //datosbancos = {this.state.bancos}
                    //actualizarUsuario={this.actualizarUsuario}
                    //bloquearUsuario={this.bloquearUsuario}
                    //desbloquearUsuario={this.desbloquearUsuario}
                    //cambiarContrasena={this.cambiarContrasena}
                    //verHistorial={this.verHistorial}
                    //bloquearUsuarioCliente={this.bloquearUsuarioCliente}
                    //onApproveFiles = {this.changeStatusDocumentation}
                    perms={this.props.perms}

                    // busqueda
                    busquedaComuna={this.state.busquedaComuna}
                    realizarBusquedaComuna={this.realizarBusqueda.bind(this, 'busquedaComuna')}
                    busquedaRUN={this.state.busquedaRUN}
                    realizarBusquedaRUN={this.realizarBusqueda.bind(this, 'busquedaRUN')}
                    busquedaNombre={this.state.busquedaNombre}
                    realizarBusquedaNombre={this.realizarBusqueda.bind(this, 'busquedaNombre')}
                    busquedaApellido={this.state.busquedaApellido}
                    realizarBusquedaApellido={this.realizarBusqueda.bind(this, 'busquedaApellido')}
                    busquedaCaptador={this.state.busquedaCaptador}
                    realizarBusquedaCaptador={this.realizarBusqueda.bind(this, 'busquedaCaptador')}
                    //busquedaVigencia={this.state.busquedaVigencia}
                    //realizarBusquedaVigencia={this.realizarBusqueda.bind(this, 'busquedaVigencia')}
                    //seachStatusContract={this.state.searchStatusContract}
                    //searchingStatusContract={this.realizarBusqueda.bind(this, 'searchStatusContract')}
                    //clientes={this.props.clientes}
                    fetchUsuarios={this.fetchUsuarios}
        />*/}
            </div>
        )
    }
}
/*OperadoresPendientes.childContextTypes = {
    uploadDNIFront: PropTypes.func,
    uploadDNIBack: PropTypes.func,
    uploadCertificate: PropTypes.func,
    uploadContract: PropTypes.func,
    uploadCredential: PropTypes.func,
    progressStatusDocumentation: PropTypes.func,
    isWrongFile: PropTypes.func,
}*/


// WEBPACK FOOTER //
// ./frontEnd/admin/OperadoresPendientes/OperadoresPendientes.jsx